import * as React from 'react';

import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';

import {useGetRoles} from '../roles-permissions/graphql/hooks/use-get-roles';

export function RolesPermissionsSidebarSection() {
    const {roles, isLoading} = useGetRoles();

    return (
        <SidebarSection
            title='Roles & permissions'
            links={[
                {to: '/setup/user?manageRolePermissions', label: 'Manage all', type: 'manage'},
                ...(roles
                    ? roles.map((role) => ({
                          to: `/setup/user?manageRolePermissions&roleId=${role.id}`,
                          isActive:
                              window.location.search === `?manageRolePermissions&roleId=${role.id}`,
                          label: role.name,
                          count: role.usersCount,
                      }))
                    : []),
            ]}
            isLoading={isLoading}
        />
    );
}
